import React from "react"
import styled from "@emotion/styled"
import { Container, Flex } from "theme-ui"
import CompanyLogos from "components/company-logos"

const Wrapper = styled.div`
    position: relative;
    text-align: center;
    // min-height: 1192px;
    margin-bottom: 3rem;
    & h2 {
        margin-bottom: 0;
    }
    & p {
        color: ${(props) => props.theme.colors.dark_grey_2};
    }
    @media (max-width: ${(props) => props.theme.breakpoints[8]}) {
        padding: 0 2rem;
    }
    @media (max-width: ${(props) => props.theme.breakpoints[6]}) {
        & h2 {
            margin-top: 0;
        }
    }
    @media (max-width: ${(props) => props.theme.breakpoints[4]}) {
        & p {
            font-size: 16px;
        }
    }
    @media (max-width: ${(props) => props.theme.breakpoints[3]}) {
        & p {
            font-size: 15px;
        }
    }
    @media (max-width: ${(props) => props.theme.breakpoints[2]}) {
        & p {
            font-size: 13px;
        }
    }
`

function OurCompany({ description }) {
    return (
        <Wrapper>
            <Container>
                <Flex sx={{ justifyContent: "center" }}>
                    <h2>Our Companies</h2>
                </Flex>
                <Flex
                    className="position"
                    sx={{
                        justifyContent: "center",
                    }}
                >
                    <div dangerouslySetInnerHTML={{ __html: description }} />
                </Flex>
                <Flex
                    sx={{
                        justifyContent: "center",
                        margin: "auto",
                    }}
                ></Flex>
                <CompanyLogos />
            </Container>
        </Wrapper>
    )
}

export default OurCompany
